/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientsEndpointResponse
 */
export interface ClientsEndpointResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientsEndpointResponse
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof ClientsEndpointResponse
     */
    fullVersion: string;
    /**
     * 
     * @type {string}
     * @memberof ClientsEndpointResponse
     */
    platform: string;
    /**
     * 
     * @type {string}
     * @memberof ClientsEndpointResponse
     */
    file: string;
}

export function ClientsEndpointResponseFromJSON(json: any): ClientsEndpointResponse {
    return ClientsEndpointResponseFromJSONTyped(json, false);
}

export function ClientsEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientsEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': json['version'],
        'fullVersion': json['full_version'],
        'platform': json['platform'],
        'file': json['file'],
    };
}

export function ClientsEndpointResponseToJSON(value?: ClientsEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': value.version,
        'full_version': value.fullVersion,
        'platform': value.platform,
        'file': value.file,
    };
}


